module.exports = __webpack_public_path__ + "static/media/tigerflix_g.9243c494.png";